
const PLAN_TYPES = {
  ANNUAL: 'annual',
  MONTHLY: 'monthly',
  ANNUAL_AND_MONTHLY: 'annualAndMonthly',
};

export default PLAN_TYPES;
